export default __webpack_public_path__ + "static/media/contact-tablet.3e5ff56f.jpg";